import styled from 'styled-components';

export const GuessesRowItem = styled.div`
  flex: 0;
  padding: 0 4px;
`;
